import React, { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import ChevronRight from '@gravity-ui/icons/ChevronRight';

import { LinkMobile } from './LinkMobile';
import styles from './MenuMobile.module.scss';

export interface IMenuMobileItem {
    value: string;
    content: React.ReactNode;
    items?: IMenuMobileItem[];
}

export const MenuMobile: FC<
    PropsWithChildren<{ menuItems: IMenuMobileItem[]; externalAsideLinks: IMenuMobileItem[] }>
> = ({ children, externalAsideLinks, menuItems }) => {
    const { pathname } = useLocation();

    const fondIndex = menuItems.findIndex((menuItem) => menuItem?.value?.includes(pathname));

    const currentIndex = fondIndex === -1 ? 0 : fondIndex;
    const currentMenuItem = menuItems[currentIndex];

    const menuItemsAboveCurrentPage = menuItems.slice(0, currentIndex);
    const menuItemsBelowCurrentPage = menuItems.slice(currentIndex + 1);

    return (
        <>
            {menuItemsAboveCurrentPage.map((menuItem) => (
                <LinkMobile key={menuItem.value} to={menuItem.value} text={menuItem?.content} />
            ))}
            <LinkMobile key={currentMenuItem.value} to={currentMenuItem.value} text={currentMenuItem.content} />
            {children}
            {menuItemsBelowCurrentPage.map((menuItem) => (
                <LinkMobile key={menuItem.value} to={menuItem.value} text={menuItem.content} isCurrent />
            ))}
            {externalAsideLinks.map((linkItem) => (
                <a key={linkItem.value} className={styles.navLinkMobile} href={linkItem.value}>
                    <ChevronRight />
                    {linkItem.content}
                </a>
            ))}
        </>
    );
};
